import { create } from 'zustand';

/**
 * @typedef {import('./authStore.types').RamblaUser} RamblaUser
 * @typedef {import('./authStore.types').AuthStore} AuthStore
 */

/**
 * Auth store for managing user authentication state.
 * @type {import('zustand').UseBoundStore<import('zustand').StoreApi<AuthStore>>}
 */
export const useAuthStore = create((set) => ({
  accessToken: null,
  user: null,
  role: null,
  isSuperUser: false,
  isImpersonating: false,

  /**
   * @param {string|null} accessToken
   */
  setAccessToken: (accessToken) => {
    set({ accessToken });
  },

  /**
   * @param {RamblaUser} user
   */
  setUser: (user) => {
    const role = user.admin_details ? 'ADMIN' : 'RETAILER';
    const isSuperUser = !!user.is_superuser;
    const isImpersonating = !!user.impersonated_by;
    set({ user, role, isSuperUser, isImpersonating });
  },

  clearAuth: () => {
    set({
      accessToken: null,
      user: null,
      role: null,
      isSuperUser: false,
      isImpersonating: false,
    });
  },
}));
